import axios from "axios";

// Create a global axios instance
axios.defaults.baseURL = "/"; // Adjust if backend runs on a different URL

// Request Interceptor: Attach token to all requests
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor: Handle token expiration and refresh
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Check for token expiration (401 Unauthorized OR 403 Forbidden)
    if (
      (error.response?.status === 401 || error.response?.status === 403) &&
      error.response?.data?.error === "Token expired" &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true; // Prevent infinite retry loops

      try {
        const refreshToken = localStorage.getItem("refreshToken");

        if (!refreshToken) {
          console.warn("No refresh token found, redirecting to login...");
          localStorage.removeItem("token");
          localStorage.removeItem("refreshToken");
          window.location.href = "/login";
          return Promise.reject(error);
        }

        // Request new access token
        const { data } = await axios.post("/api/auth/refresh", { refreshToken });

        // Store new token
        localStorage.setItem("token", data.token);

        // Update authorization header for the original request
        originalRequest.headers.Authorization = `Bearer ${data.token}`;

        // Retry original request with new token
        return axios(originalRequest);
      } catch (refreshError) {
        console.error("Token refresh failed:", refreshError);

        // Remove expired tokens
        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");

        // Redirect to login page
        window.location.href = "/login";
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);
